module.exports = __webpack_public_path__ + "img/Nara-01.fc544980.jpg";